export enum PushAction {
  OPEN_PROFILE = 'open_profile',
  OPEN_QUESTIONS = 'open_questions',
}
